// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__XGfokeIdlhljyLrJoTUw {
  border: 1px solid var(--cp-borderSubtle);
  border-radius: 3px;
  box-shadow: 0 0 12px -6px rgb(var(--cp-blackRgb) / 0.25);
}

.header__wuGrO61h0mxJCT13pKKi {
  /* offset the margin so this element's border overlaps the root's gray border */
  margin: -1px;
  /* this overlaps the parent border so there can be a hover border for the header only without jumping */
  border: 1px solid var(--cp-borderSubtle);
  border-radius: 3px;
  background: var(--cp-neutralLighter);
  padding: 0;
  display: flex;
  align-items: center;
  line-height: 1;
}
.header__wuGrO61h0mxJCT13pKKi:hover,
.header__wuGrO61h0mxJCT13pKKi:active {
  border-color: var(--cp-borderHover);
}
.header__wuGrO61h0mxJCT13pKKi.expanded__xUYhCGbIYOflP2MeZWAZ {
  /* change the margin-bottom when expanded so the border still shows up */
  margin-bottom: 0;
}
.header__wuGrO61h0mxJCT13pKKi.error__tYu_98mP3NNuncdgfx2e {
  background: var(--cp-errorLight);
}
.header__wuGrO61h0mxJCT13pKKi.success__sn79vVqYMTENjCFDp9o2 {
  background: var(--cp-successLight);
}
.header__wuGrO61h0mxJCT13pKKi.warning__uBvWcRQWreqOQcQx11QC {
  background: var(--cp-warningLight);
}

h3.headerButtonWrapper__kGHJtSdatcFi9k0NuFhK {
  /* Ignore this element for flexbox layout purposes (children act as if they're directly under parent) */
  display: contents;
  margin: 0;
  padding: 0;
}

/* buttons can't use display: contents due to browser bugs that would make it
not accessible with the tab key */
button.headerButton__DPU_BgMDvX9c3bs_hgJf {
  width: 100%;
  margin: 0;
  /* Set padding on the button so it's included in the click target */
  padding: 8px 16px;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* The chevron icon is 20x20. We want it to take up a 32x32 area. */
.expandIcon__jZlxmg1VmtWr__jzMk1T {
  width: 20px;
  height: 20px;
  padding: 6px;
  transition: transform 0.1s ease-in-out;
}

.expandIcon__jZlxmg1VmtWr__jzMk1T.collapsed__YFo31CeXA_PU_CMg_zld {
  padding-top: 8px;
  padding-bottom: 4px;
  transform: rotate(-90deg);
}

.headerEnd__cUZadJUKd9B70qLziRSU {
  /* this makes it right-aligned */
  margin-left: auto;
  font-size: var(--cp-fontSizeSm);
  font-weight: 400;
  text-align: end;
}

.headerCommands___LelyTIepA5pC2N_dHW2 {
  margin-right: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: end;
}

.title__ERmJeA26FxA8sETCCLQS {
  font-size: var(--cp-fontSizeMd);
  font-weight: 500;
  /* for h4 element */
  margin: 0;
  padding: 0;
}

.contentHidden__QUAuafbYFPvmVwOUOqYN {
  display: none;
}

.content__xPBZFnKM72fLspTwq_5u {
  background: var(--cp-neutralLighterAlt);
  /* 24px optically aligns with the icons in the header */
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* Increase line-height so it's easier to read */
  line-height: 1.2em;
}
.content__xPBZFnKM72fLspTwq_5u li {
  margin: 3px 0;
}
.content__xPBZFnKM72fLspTwq_5u p {
  margin: 0;
}
.content__xPBZFnKM72fLspTwq_5u p + p {
  margin-top: 8px;
}

.itemName__MP8Xx_w4X_xqx1QcYVfk {
  font-size: var(--cp-fontSizeMd);
  font-weight: 600;
  text-transform: uppercase;
  padding-bottom: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ResultsAccordion/ResultsAccordion.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,+EAA+E;EAC/E,YAAY;EACZ,uGAAuG;EACvG,wCAAwC;EACxC,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mCAAmC;AACrC;AACA;EACE,wEAAwE;EACxE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,uGAAuG;EACvG,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;iCACiC;AACjC;EACE,WAAW;EACX,SAAS;EACT,mEAAmE;EACnE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,uDAAuD;EACvD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".root {\n  border: 1px solid var(--cp-borderSubtle);\n  border-radius: 3px;\n  box-shadow: 0 0 12px -6px rgb(var(--cp-blackRgb) / 0.25);\n}\n\n.header {\n  /* offset the margin so this element's border overlaps the root's gray border */\n  margin: -1px;\n  /* this overlaps the parent border so there can be a hover border for the header only without jumping */\n  border: 1px solid var(--cp-borderSubtle);\n  border-radius: 3px;\n  background: var(--cp-neutralLighter);\n  padding: 0;\n  display: flex;\n  align-items: center;\n  line-height: 1;\n}\n.header:hover,\n.header:active {\n  border-color: var(--cp-borderHover);\n}\n.header.expanded {\n  /* change the margin-bottom when expanded so the border still shows up */\n  margin-bottom: 0;\n}\n.header.error {\n  background: var(--cp-errorLight);\n}\n.header.success {\n  background: var(--cp-successLight);\n}\n.header.warning {\n  background: var(--cp-warningLight);\n}\n\nh3.headerButtonWrapper {\n  /* Ignore this element for flexbox layout purposes (children act as if they're directly under parent) */\n  display: contents;\n  margin: 0;\n  padding: 0;\n}\n\n/* buttons can't use display: contents due to browser bugs that would make it\nnot accessible with the tab key */\nbutton.headerButton {\n  width: 100%;\n  margin: 0;\n  /* Set padding on the button so it's included in the click target */\n  padding: 8px 16px;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* The chevron icon is 20x20. We want it to take up a 32x32 area. */\n.expandIcon {\n  width: 20px;\n  height: 20px;\n  padding: 6px;\n  transition: transform 0.1s ease-in-out;\n}\n\n.expandIcon.collapsed {\n  padding-top: 8px;\n  padding-bottom: 4px;\n  transform: rotate(-90deg);\n}\n\n.headerEnd {\n  /* this makes it right-aligned */\n  margin-left: auto;\n  font-size: var(--cp-fontSizeSm);\n  font-weight: 400;\n  text-align: end;\n}\n\n.headerCommands {\n  margin-right: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: end;\n}\n\n.title {\n  font-size: var(--cp-fontSizeMd);\n  font-weight: 500;\n  /* for h4 element */\n  margin: 0;\n  padding: 0;\n}\n\n.contentHidden {\n  display: none;\n}\n\n.content {\n  background: var(--cp-neutralLighterAlt);\n  /* 24px optically aligns with the icons in the header */\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  /* Increase line-height so it's easier to read */\n  line-height: 1.2em;\n}\n.content li {\n  margin: 3px 0;\n}\n.content p {\n  margin: 0;\n}\n.content p + p {\n  margin-top: 8px;\n}\n\n.itemName {\n  font-size: var(--cp-fontSizeMd);\n  font-weight: 600;\n  text-transform: uppercase;\n  padding-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__XGfokeIdlhljyLrJoTUw`,
	"header": `header__wuGrO61h0mxJCT13pKKi`,
	"expanded": `expanded__xUYhCGbIYOflP2MeZWAZ`,
	"error": `error__tYu_98mP3NNuncdgfx2e`,
	"success": `success__sn79vVqYMTENjCFDp9o2`,
	"warning": `warning__uBvWcRQWreqOQcQx11QC`,
	"headerButtonWrapper": `headerButtonWrapper__kGHJtSdatcFi9k0NuFhK`,
	"headerButton": `headerButton__DPU_BgMDvX9c3bs_hgJf`,
	"expandIcon": `expandIcon__jZlxmg1VmtWr__jzMk1T`,
	"collapsed": `collapsed__YFo31CeXA_PU_CMg_zld`,
	"headerEnd": `headerEnd__cUZadJUKd9B70qLziRSU`,
	"headerCommands": `headerCommands___LelyTIepA5pC2N_dHW2`,
	"title": `title__ERmJeA26FxA8sETCCLQS`,
	"contentHidden": `contentHidden__QUAuafbYFPvmVwOUOqYN`,
	"content": `content__xPBZFnKM72fLspTwq_5u`,
	"itemName": `itemName__MP8Xx_w4X_xqx1QcYVfk`
};
export default ___CSS_LOADER_EXPORT___;
